import React from "react";
import { fmtInt } from "../collection/badgeFormat";
import type { BadgeGoal } from "../types";
import { goalPct } from "./goalFormat";
import "./nextBadges.css";

/** A goal's progress toward its next badge: a flat bar in a black frame. */
export const GoalBar: React.FC<{
  goal: Pick<BadgeGoal, "pct" | "current" | "target">;
  className?: string;
}> = ({ goal, className }) => {
  const pct = goalPct(goal);
  return (
    <span
      className={className ? `bnext-bar ${className}` : "bnext-bar"}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct}
      aria-valuetext={`${fmtInt(goal.current)} of ${fmtInt(goal.target)}`}
    >
      <span className="bnext-bar__fill" style={{ width: `${pct}%` }} />
    </span>
  );
};

export default GoalBar;
